import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Stack, Typography } from '@mui/material';
import { colors } from '../../../utils/colors';

import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from '@mui/lab';

import moment from 'moment';
import numbro from 'numbro';

export const HistoricoAccionModal = ({ open: { open = false, historico: historial = [], reclutamiento = false }, setOpenHistoricoAccion }) => {
  const historico = (Array.isArray(historial) ? historial : []).filter((item) => item && typeof item === 'object');
  return (
    <Dialog PaperProps={{ sx: { width: '60%', height: reclutamiento ? '45%' : `${60 + 7 * historico.length}%` } }} open={open} maxWidth="lg">
      <DialogTitle sx={{ textTransform: 'uppercase' }} className="text-mem text-center">
        Historial
      </DialogTitle>
      <Divider sx={{ color: colors.azulMem }} />

      <DialogContent>
        <Stack mt={2}>
          <Timeline position="alternate">
            {historico.map((item, index) => (
              <>
                <TimelineItem key={index} hidden={reclutamiento}>
                  <TimelineOppositeContent sx={{ m: 'auto 0' }} align="right" variant="body2" color={colors.rojoMem} fontWeight="bold">
                    {moment(item.fechaReclutamiento).format('DD/MM/yyyy')}
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineConnector />
                    <TimelineDot
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#eeeeee',
                        backgroundColor: colors.rojoMem,
                        fontWeight: 'bold',
                        p: 0,
                      }}
                    >
                      {index + 1}
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: '12px', px: 2 }}>
                    <Typography variant="h6" component="span">
                      ANTERIOR
                    </Typography>

                    <Typography mt={1.5} fontSize={12}>
                      <b>Cargo:</b> {item.cargoOld}
                    </Typography>

                    <Typography mt={1.5} fontSize={12}>
                      <b>Sueldo:</b> RD$ ${numbro(Number.isFinite(Number(item.sueldoOld)) ? Number(item.sueldoOld) : 0).format({ thousandSeparated: true })}
                    </Typography>

                    <Typography mt={1.5} fontSize={12}>
                      <b>Área Organizacional:</b> {item.areaOrganizacionalOld}
                    </Typography>

                    {/* <Typography mt={1.5} fontSize={12}><b>Área de Evaluación de Desempeño Anterior:</b> {item.areaReporteOld}</Typography> */}

                    <Typography mt={1.5} fontSize={12}>
                      <b>Área Padre Anterior:</b> {item.areaPadreOld ?? 'N/A'}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>

                <TimelineItem key={index + 1}>
                  <TimelineOppositeContent sx={{ m: 'auto 0' }} align="right" variant="body2" color={colors.azulMem} fontWeight="bold">
                    {moment(item.fechaEfectividad).format('DD/MM/yyyy')}
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineConnector />
                    <TimelineDot
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#eeeeee',
                        backgroundColor: colors.azulMem,
                        fontWeight: 'bold',
                        p: 0,
                      }}
                    >
                      {reclutamiento ? index + 1 : index + 2}
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: '12px', px: 2 }}>
                    <Typography variant="h6" component="span">
                      ACTUAL
                    </Typography>

                    <Typography mt={1.5} fontSize={12}>
                      <b>Cargo:</b> {item.cargoNew}
                    </Typography>

                    <Typography mt={1.5} fontSize={12}>
                      <b>Sueldo:</b> RD$ ${numbro(Number.isFinite(Number(item.sueldoNew)) ? Number(item.sueldoNew) : 0).format({ thousandSeparated: true })}
                    </Typography>

                    <Typography mt={1.5} fontSize={12}>
                      <b>Área Organizacional:</b> {item.areaOrganizacionalNew}
                    </Typography>

                    {/* <Typography mt={1.5} fontSize={12}><b>Área de Evaluación de Desempeño:</b> {item.areaReporteNew}</Typography> */}

                    <Typography mt={1.5} fontSize={12}>
                      <b>Área Padre Actual:</b> {item.areaPadreNew ?? 'N/A'}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </>
            ))}
          </Timeline>
        </Stack>
      </DialogContent>

      <DialogActions className="justify-content-center">
        <button
          id="btn-cancelar"
          type="button"
          onClick={() => setOpenHistoricoAccion({ open: false, historico: [], reclutamiento: false })}
          className="btn btn-danger"
        >
          <DoNotDisturbAltIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} />
          CANCELAR
        </button>
      </DialogActions>
    </Dialog>
  );
};
